<div class="cd-filter display-lg static-side filter-is-visible" [ngClass]="{ 'filter-is-visible': showSearchForm }">
    <div class="filter-header">
        <i class="fa fa-sliders" aria-hidden="true"></i>Filter Events
    </div>
    <button role="button"
            class="cd-close"
            (click)="showFilter()"
            data-testid="2E3E12AD-441D-480E-B74E-D4BFFF82630E">
        <span class="sr-only">
            Click to close slide-out search bar
        </span>
    </button>
    <div class="filter-box">
        <div class="section-title">
            <h5 class="no-border"><i class="fa fa-fw fa-sliders" aria-hidden="true"></i>Filter Events</h5>
        </div>
        <div class="search-section">
            <div class="form-group">
                <label for="namesearch">
                    Course Name
                </label>
                <input placeholder="Search by Name"
                       id="namesearch"
                       class="form-control"
                       (keydown.enter)="search()"
                       [formControl]="eventSearchForm.controls.courseName"
                       data-testid="ADBA9124-3CDB-465D-A210-9D1950E1915E">
            </div>
            <div class="form-group">
                <label for="event_id">
                    Event ID
                </label>
                <number-input [placeholder]="'Search by Event ID'" [id]="'event_id'" [class]="'form-control'"
                    (onEnterPress)="search()" [formControlReference]="eventSearchForm.controls.eventId"
                    data-testid="C83C0FF7-C536-4F62-859D-B73DD4817FCE"></number-input>
            </div>
            <div class="form-group checkbox-group">
              <div class="app-checkbox box-md">
                <label for="FutureEvents">
                  <input type="checkbox"
                         id="FutureEvents"
                         (keydown.enter)="search()"
                         [formControl]="eventSearchForm.controls.showFutureEvents"
                         data-testid="8AC62793-F091-4FBD-A1A9-66990B5B58E3">
                  <span>Show Future Events (next {{eventSearchFuture}} days)</span>
                </label>
              </div>
            </div>
        </div>
        <div class="app-buttons btm">
            <div class="btn-box">
                <button type="submit" id="btnFilter" class="btn primary-btn" (click)="search()" data-testid="1B77C417-FEFD-490C-A16F-DB5AECA5B483" [disabled]="!isOnline">
                    <i class="fa fa-search fa-fw" aria-hidden="true"></i>Search
                </button>
                <button id="btnClearFilters" class="btn btn-gray btn-block" (click)="reset()" data-testid="21FDD0E4-D481-4952-980F-617F5EC4F355">
                    <i class="fa fa-refresh fa-fw" aria-hidden="true"></i>Reset
                </button>
            </div>
        </div>
    </div>
</div>
